// extracted by mini-css-extract-plugin
module.exports = {"petrol":"CustomMalt-TextButton-petrol-85cf834c"};